export default __webpack_public_path__ + "static/media/4044.d2c39ce2.jpg";